<template>
  <button @click="selectFile()" class="btn btn-attach">
    <img src="@/assets/images/icons/attach.svg" alt="attach" />
    <input
      type="file"
      class="file-input"
      accept="image/*"
      ref="fileInput"
      v-if="show_input"
      @change="onFileChange"
    />
  </button>
</template>

<script>
export default {
  name: "widget-attach-file",
  props: {},
  data() {
    return {
      show_input: true,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
    async onFileChange(e) {
      let vm = this;
      vm.show_input = false;
      // Check file size 5MB
      if (e.target.files[0].size > 5000000) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Oops!",
          text: "File size is too large",
        });
        vm.show_input = true;
        return;
      }
      let obj = {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
        ext: e.target.files[0].name.split(".").pop(),
        base64: await vm.toBase64(e.target.files[0]),
      };
      vm.$emit("change", obj);
      vm.show_input = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-attach {
  background-color: transparent;
  border: none;
  width: min-content;
  .file-input {
    display: none;
  }
}
</style>
